import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => useContext(LanguageContext);

const translations = {
  ar: {
    home: 'الرئيسية',
    shop: 'المتجر',
    about: 'عن برستيج',
    lessons: 'دروس ومعلومات',
    contact: 'تواصل معنا',
    cart: 'السلة',
    account: 'حسابي',
    login: 'تسجيل الدخول',
    register: 'إنشاء حساب',
    logout: 'تسجيل الخروج',
    admin: 'لوحة التحكم',
    search: 'بحث',
    searchPlaceholder: 'ابحث عن منتج...',
    newArrivals: 'جديدنا',
    viewAll: 'عرض الكل',
    addToCart: 'أضف إلى السلة',
    outOfStock: 'نفذ المخزون',
    inStock: 'متوفر',
    price: 'السعر',
    quantity: 'الكمية',
    total: 'الإجمالي',
    subtotal: 'المجموع الفرعي',
    checkout: 'إتمام الشراء',
    continueShopping: 'متابعة التسوق',
    emptyCart: 'سلة التسوق فارغة',
    productDetails: 'تفاصيل المنتج',
    description: 'الوصف',
    specifications: 'المواصفات',
    beadsCount: 'عدد الخرز',
    beadsSize: 'حجم الخرزة',
    sku: 'رمز المنتج',
    category: 'الفئة',
    categories: 'الفئات',
    filterBy: 'تصفية حسب',
    sortBy: 'ترتيب حسب',
    priceLowHigh: 'السعر: من الأقل للأعلى',
    priceHighLow: 'السعر: من الأعلى للأقل',
    newest: 'الأحدث',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    name: 'الاسم',
    phone: 'رقم الهاتف',
    address: 'العنوان',
    city: 'المدينة',
    country: 'الدولة',
    payNow: 'ادفع الآن',
    orderSummary: 'ملخص الطلب',
    shippingAddress: 'عنوان الشحن',
    paymentMethod: 'طريقة الدفع',
    orders: 'الطلبات',
    orderNumber: 'رقم الطلب',
    orderStatus: 'حالة الطلب',
    orderDate: 'تاريخ الطلب',
    pending: 'قيد الانتظار',
    processing: 'قيد المعالجة',
    shipped: 'تم الشحن',
    delivered: 'تم التسليم',
    cancelled: 'ملغي',
    dashboard: 'الرئيسية',
    products: 'المنتجات',
    users: 'المستخدمون',
    reports: 'التقارير',
    settings: 'الإعدادات',
    heroTitle: 'خيارات أكثر للتغليف',
    heroSubtitle: 'مع كل مسباح',
    footerTagline: 'برستيج مسابيح - عالم من التفاصيل الجميعة',
    allRightsReserved: 'جميع الحقوق محفوظة',
    aboutUs: 'من نحن',
    ourStory: 'قصتنا',
    followUs: 'تابعنا',
    customerService: 'خدمة العملاء',
    shippingReturn: 'الشحن والإرجاع',
    privacyPolicy: 'سياسة الخصوصية',
    termsConditions: 'الشروط والأحكام',
    newsletter: 'النشرة البريدية',
    subscribeText: 'اشترك للحصول على أحدث العروض',
    subscribe: 'اشتراك',
    yourEmail: 'بريدك الإلكتروني',
    readMore: 'اقرأ المزيد',
    lessonsInfo: 'دروس ومعلومات',
    allLessons: 'جميع الدروس',
    remove: 'حذف',
    update: 'تحديث',
    save: 'حفظ',
    cancel: 'إلغاء',
    add: 'إضافة',
    edit: 'تعديل',
    delete: 'حذف',
    confirm: 'تأكيد',
    successAdded: 'تمت الإضافة بنجاح',
    stock: 'المخزون',
    revenue: 'الإيرادات',
    totalOrders: 'إجمالي الطلبات',
    totalUsers: 'إجمالي المستخدمين',
    totalProducts: 'إجمالي المنتجات',
    salesReport: 'تقرير المبيعات',
    thisMonth: 'هذا الشهر',
    lastMonth: 'الشهر الماضي',
    thisYear: 'هذه السنة',
    firstName: 'الاسم الأول',
    lastName: 'اسم العائلة',
    zipCode: 'الرمز البريدي',
    notes: 'ملاحظات',
    placeOrder: 'إتمام الطلب',
    orderPlaced: 'تم إرسال الطلب بنجاح',
    myAccount: 'حسابي',
    profile: 'الملف الشخصي',
    myOrders: 'طلباتي',
    wishlist: 'المفضلة',
    addToWishlist: 'أضف للمفضلة',
    removeFromWishlist: 'إزالة من المفضلة',
    trackOrder: 'تتبع الطلب',
    view: 'عرض',
    actions: 'إجراءات',
    status: 'الحالة',
    date: 'التاريخ',
    customer: 'العميل',
    amount: 'المبلغ',
    reviews: 'التقييمات والمراجعات',
  },
  en: {
    home: 'Home',
    shop: 'Shop',
    about: 'About Prestige',
    lessons: 'Lessons & Info',
    contact: 'Contact Us',
    cart: 'Cart',
    account: 'Account',
    login: 'Login',
    register: 'Register',
    logout: 'Logout',
    admin: 'Admin Panel',
    search: 'Search',
    searchPlaceholder: 'Search for a product...',
    newArrivals: 'New Arrivals',
    viewAll: 'View All',
    addToCart: 'Add to Cart',
    outOfStock: 'Out of Stock',
    inStock: 'In Stock',
    price: 'Price',
    quantity: 'Quantity',
    total: 'Total',
    subtotal: 'Subtotal',
    checkout: 'Checkout',
    continueShopping: 'Continue Shopping',
    emptyCart: 'Your cart is empty',
    productDetails: 'Product Details',
    description: 'Description',
    specifications: 'Specifications',
    beadsCount: 'Beads Count',
    beadsSize: 'Bead Size',
    sku: 'SKU',
    category: 'Category',
    categories: 'Categories',
    filterBy: 'Filter By',
    sortBy: 'Sort By',
    priceLowHigh: 'Price: Low to High',
    priceHighLow: 'Price: High to Low',
    newest: 'Newest',
    email: 'Email',
    password: 'Password',
    name: 'Name',
    phone: 'Phone',
    address: 'Address',
    city: 'City',
    country: 'Country',
    payNow: 'Pay Now',
    orderSummary: 'Order Summary',
    shippingAddress: 'Shipping Address',
    paymentMethod: 'Payment Method',
    orders: 'Orders',
    orderNumber: 'Order #',
    orderStatus: 'Status',
    orderDate: 'Order Date',
    pending: 'Pending',
    processing: 'Processing',
    shipped: 'Shipped',
    delivered: 'Delivered',
    cancelled: 'Cancelled',
    dashboard: 'Dashboard',
    products: 'Products',
    users: 'Users',
    reports: 'Reports',
    settings: 'Settings',
    heroTitle: 'More Packaging Options',
    heroSubtitle: 'With Every Misbaha',
    footerTagline: 'Prestige Mesbah - A World of Beautiful Details',
    allRightsReserved: 'All Rights Reserved',
    aboutUs: 'About Us',
    ourStory: 'Our Story',
    followUs: 'Follow Us',
    customerService: 'Customer Service',
    shippingReturn: 'Shipping & Returns',
    privacyPolicy: 'Privacy Policy',
    termsConditions: 'Terms & Conditions',
    newsletter: 'Newsletter',
    subscribeText: 'Subscribe for latest offers',
    subscribe: 'Subscribe',
    yourEmail: 'Your email',
    readMore: 'Read More',
    lessonsInfo: 'Lessons & Info',
    allLessons: 'All Lessons',
    remove: 'Remove',
    update: 'Update',
    save: 'Save',
    cancel: 'Cancel',
    add: 'Add',
    edit: 'Edit',
    delete: 'Delete',
    confirm: 'Confirm',
    successAdded: 'Added successfully',
    stock: 'Stock',
    revenue: 'Revenue',
    totalOrders: 'Total Orders',
    totalUsers: 'Total Users',
    totalProducts: 'Total Products',
    salesReport: 'Sales Report',
    thisMonth: 'This Month',
    lastMonth: 'Last Month',
    thisYear: 'This Year',
    firstName: 'First Name',
    lastName: 'Last Name',
    zipCode: 'Zip Code',
    notes: 'Notes',
    placeOrder: 'Place Order',
    orderPlaced: 'Order placed successfully',
    myAccount: 'My Account',
    profile: 'Profile',
    myOrders: 'My Orders',
    wishlist: 'Wishlist',
    addToWishlist: 'Add to Wishlist',
    removeFromWishlist: 'Remove from Wishlist',
    trackOrder: 'Track Order',
    view: 'View',
    actions: 'Actions',
    status: 'Status',
    date: 'Date',
    customer: 'Customer',
    amount: 'Amount',
    reviews: 'Reviews & Testimonials',
  }
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem('hjr_lang') || 'ar');

  useEffect(() => {
    localStorage.setItem('hjr_lang', lang);
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
  }, [lang]);

  const t = (key) => translations[lang]?.[key] || key;
  const isRTL = lang === 'ar';

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, isRTL }}>
      {children}
    </LanguageContext.Provider>
  );
};
